import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppConfig } from "../classes/app-config.class";
import { IAppConfig } from "../models/app-config.model";
import { IAppExtras, TAny } from "../models/common.type";
import { TOKEN_APP_CONFIG } from "../models/constant";

@Injectable({
    providedIn: 'root'
})
export class AppConfiguration {
    private _data: AppConfig = new AppConfig();
    public data$ = new BehaviorSubject<AppConfig>(this._data);

    constructor(@Inject(TOKEN_APP_CONFIG) public appConfig: BehaviorSubject<Partial<AppConfig>>) {
        if (appConfig) {
            this._data = new AppConfig(appConfig.value as IAppConfig);
            this.emitChanges();
        }
    }

    public get data(): AppConfig { return this._data; }

    public get hostUrl(): string { return this.appConfig.value.hostUrl || '/unknwon/'; }

    public setProps(prop: string, value: string, update: boolean = true) {
        if (prop in this._data) {
            (this._data as TAny)[prop] = value;
            if (update) {
                this.emitChanges();
            }
        }
    }

    public updateProps(data: Partial<IAppConfig>): void {
        if (Object.keys(data).length) {
            Object.keys(data).forEach((prop: string) => {
                this.setProps(prop, (data as TAny)[prop], false);
            });
            this.emitChanges();
        }
    }

    public updateExtraProps(data: IAppExtras): void {
        if (Object.keys(data).length) {
            Object.keys(data).forEach((prop: string) => {
                this._data.setExtransProp(prop, (data as TAny)[prop]);
            });
            this.emitChanges();
        }
    }

    public emitChanges(): void {
        this.data$.next(this._data);
        this.appConfig.next(this._data);
    }

}